export function NotFoundPage() {
    return <p>Pagina bestaat niet</p>;
}
